import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * An array of objects which depict the links (crumbs)
   */
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    classList: PropTypes.string
  })).isRequired,
  /**
   * Aria-label for the navigation element containing the links
   */
  labelText: PropTypes.string.isRequired,
  /** Classes to add to the parent element */
  classList: PropTypes.string
};
function Breadcrumb(_ref) {
  var _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    crumbs = _ref.crumbs,
    labelText = _ref.labelText;
  var links = crumbs.map(function (_ref2) {
    var _ref2$classList = _ref2.classList,
      crumbClassList = _ref2$classList === void 0 ? null : _ref2$classList,
      href = _ref2.href,
      label = _ref2.label;
    return /*#__PURE__*/React__default.createElement("li", {
      key: "breadcrumb-link-".concat(href)
    }, /*#__PURE__*/React__default.createElement("a", {
      href: href,
      className: crumbClassList
    }, label));
  });
  return /*#__PURE__*/React__default.createElement("nav", {
    "aria-label": labelText,
    className: "breadcrumb ".concat(classList)
  }, /*#__PURE__*/React__default.createElement("ol", null, links));
}
Breadcrumb.propTypes = propTypes;

export { Breadcrumb as default };
//# sourceMappingURL=Breadcrumb.js.map
